import { ROUTES } from '@/shared/lib/constants';

/**
 * 태그를 새 탭에서 여는 공통 유틸 함수
 *
 * @description
 * 태그 FQN을 URL 인코딩하고 새 탭에서 태그 상세 페이지를 엽니다.
 *
 * @param tagFQN - 태그의 Fully Qualified Name
 *
 * @example
 * ```typescript
 * openTagInNewTab('Classification.Tier.Tier1');
 * // 새 탭에서 /tags/detail/Classification.Tier.Tier1 페이지 열림
 * ```
 */
export const openTagInNewTab = (tagFQN: string): void => {
  const encodedFqn = encodeURIComponent(tagFQN);
  window.open(`${ROUTES.TAGS_DETAIL}/${encodedFqn}`, '_blank');
};
